<template>
    <div class="py-1">
        <div
            v-if="!hideLabel"
            :class="{ invisible: invisibleLabel }"
            class="-mb-0.5"
        >
            <FormLabel :required="required">
                {{ label }}
            </FormLabel>
        </div>
        <div>
            <slot></slot>
        </div>
        <div>
            <small
                v-if="error"
                class="text-sm text-red-600"
            >
                {{ error }}
            </small>
        </div>
        <div
            v-if="slots.helperText"
            class="mt-1"
        >
            <small
                class="text-xs text-gray-500 flex items-center justify-start gap-x-1"
            >
                <Icon
                    name="info-circle"
                    class="w-3 h-3"
                />
                <div>
                    <slot name="helperText"></slot>
                </div>
            </small>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useSlots } from 'vue'
    import FormLabel from '@/Shared/Component/Forms/FormLabel.vue'
    import Icon from '@/Shared/Component/Icon.vue'

    defineProps({
        label: {
            type: String,
            default: null,
        },
        invisibleLabel: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: null,
        },
        id: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        hideLabel: {
            type: Boolean,
            default: false,
        },
    })

    const slots: any = useSlots()
</script>
